import React, { ChangeEvent, FC, ReactElement, useCallback } from 'react';
import { Input } from 'reactstrap';
import { FormOptionModel } from '../../../../../shared/kiosk';
import { useTranslation } from '../../../../translations';
import { useExpressEditorOptions } from '../OptionContext';
import { AbstractElementEditor, UpdateFormPropsNoTrans } from './AbstractElementEditor';

export class ProductOptionEditor extends AbstractElementEditor<FormOptionModel> {
  public override getDescription(node?: FormOptionModel): React.JSX.Element {
    return <ProductOptionDescription node={node} />;
  }

  public getName(): string {
    return 'Product Option';
  }

  public getIcon(): string {
    return 'list';
  }

  public override getUpdateForm({
    node,
    update,
    // eslint-disable-next-line @typescript-eslint/no-deprecated
  }: UpdateFormPropsNoTrans<FormOptionModel>): ReactElement {
    return <ProductOptionSelector node={node} update={update} />;
  }
}

const ProductOptionDescription: FC<{ readonly node?: FormOptionModel }> = ({ node }) => {
  const options = useExpressEditorOptions();
  const option = node && options.find((o) => o.id === node.optionId);

  const { ts } = useTranslation();
  const title = node?.optionId === 'badgeName' ? ts('common.badge_name') : option?.name;

  return (
    <>
      {ts('display_option_related_to_the_form')}
      {node?.optionId && (
        <>
          <br />
          <b>{ts('option')}</b>: {title || <i>{ts('common.unknown')}</i>}
        </>
      )}
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/no-deprecated
const ProductOptionSelector: FC<UpdateFormPropsNoTrans<FormOptionModel>> = ({ update, node }) => {
  const options = useExpressEditorOptions();
  const { ts } = useTranslation();
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      if (value === 'badgeName') {
        update({ ...node, optionId: 'badgeName' });
        return;
      }

      update({
        ...node,
        optionId: Number.parseInt(value, 10),
      });
    },
    [node, update],
  );

  return (
    <div>
      <Input
        id="modalSelectOption"
        onChange={onChange}
        type="select"
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        value={node.optionId?.toString()}
      >
        <option value="badgeName">{ts('common.badge_name')}</option>
        {options.map((option) => {
          return (
            <option key={option.id} value={option.id.toString()}>
              {option.id}:{' '}
              {option.name.length > 70 ? `${option.name.slice(0, 64)}...` : option.name}
            </option>
          );
        })}
      </Input>
    </div>
  );
};
